import type { IConfig } from "@icecreamsocial/jssdk";
import { atom } from "jotai";

/**
 * data to be used for tracking conversions and creating influencers
 */
// export const dataLayerAtom = atom<Partial<Pick<IConfig, 'data'>>>({})
